/**
 * @Author: zhangxiaojian
 * @Date: 2025/5/7
 * @LastEditors: zhangxiaojian
 * @Description 全局事件通知事件名称
 **/
export default {
  GLOBAL_UPLOAD_FILE_EVENT: 'GLOBAL_UPLOAD_FILE_EVENT',// 上传文件事件
  GLOBAL_UPLOAD_CONTAINER_VISIBLE: 'GLOBAL_UPLOAD_CONTAINER_VISIBLE',// 全局上传组件显示隐藏事件
  UPLOAD_OVER_ALL_DRAG_UPLOAD: 'UPLOAD_OVER_ALL_DRAG_UPLOAD', //全局拖拽上传事件
  INIT_UPLOAD_OVER_ALL: 'INIT_UPLOAD_OVER_ALL', // 初始化全局上传组件
  OVER_ALL_UPLOAD_FILE: 'OVER_ALL_UPLOAD_FILE', // 开始执行全局文件上传事件
  OVER_ALL_UPLOAD_SUCCESS: 'OVER_ALL_UPLOAD_SUCCESS', // 全局上传成功事件
  LINK_NOT_FOUND: 'LINK_NOT_FOUND', // 链接未找到
  IMAGE_LIBRARY: { // 图片库相关事件名称
    PHYSICAL_LIBRARY: 'IMAGE_LIBRARY.PHYSICAL_LIBRARY', // 图片库服务中人物库事件名称
  }
}
export const EventBroadcastKey = {
  UPDATE_SECRET_DATA: 'UPDATE_SECRET_DATA'
}
/**
 * 全局事件总线中存储的数据名称
 */
export const EventBusDataKey = {
  VERSION: 'VERSION',
  PREFERENCESELECTORS: { // 平台配置和个人偏好字体 包含的类名（不可复用可扩展
    PREFERENCE_FONTFAMILY_SELECTORS: 'PREFERENCESELECTORS.PREFERENCE_FONTFAMILY_SELECTORS', // 平台配置和个人偏好字体或字体包影响的dom容器（默认包括稿件列表和快速浏览
    PREFERENCE_FONTSIZE_SELECTORS: 'PREFERENCESELECTORS.PREFERENCE_FONTSIZE_SELECTORS' // 个人偏好设置自定义字号影响的dom容器（默认包括快速浏览的正文部分
  },
  // 用户权限相关数据
  AUTH:{
    AUTHS: 'AUTH.AUTHS', // 用户权限数组
    MODS: 'AUTH.MODS', // 用户权限模块集合
    GROUPS: 'AUTH.GROUPS', // 用户权限模块分组集合
    USER: 'AUTH.USER' ,// 用户信息相关
    AI_ASSISTANT_SWITCH: 'AI_ASSISTANT_SWITCH',// 运营配置的AI助手开关
    FIRST_GROUPS_IS_SYSTEM: 'AUTH.FIRST_GROUPS_IS_SYSTEM',//判断菜单配置第一个页面是不是系统管理
  },
  SECRET: { // 密钥相关
    SM2_PUB_KEY: 'SECRET.SM2_PUB_KEY', // 本地生成的sm2加密的公钥
    SM2_PRI_KEY: 'SECRET.SM2_PRI_KEY', // 本地生成的sm2加密的私钥
    SM4_PRI_KEY: 'SECRET.SM4_PRI_KEY', // 服务端用于加密的sm4私钥
  },
  PUGC: {
    APP_PUB_KEY: 'PUGC.APP_PUB_KEY', // pugc登录时生成的假公钥
    APP_PRI_KEY: 'PUGC.APP_PRI_KEY', // pugc登录时生成的假私钥
    TOKEN_DATA: 'PUGC.TOKEN_DATA', // pugc登录时生成的token数据
  }
}
